import { createContext } from 'react';

const FormNativeIdContext = createContext<string | null>(null);

export default FormNativeIdContext;
